import { omit } from 'lodash'

const removeValueById = (id) => (state) => {
  return omit(state, id)
}

export default removeValueById
